module.exports = __webpack_public_path__ + "img/timeblue.0b844be1.svg";